import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JoyrideService } from 'ngx-joyride';
import { Observable } from 'rxjs';
import constants from 'src/constant.json';
import { environment } from '../../environments/environment';
import { AppState } from '../app.state';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  companyName: any;
  constructor(
    private http: HttpClient,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public appState: AppState,
    private joyrideService: JoyrideService
  ) { }

  userAuthenticate(userName, password): Observable<any> {
    return new Observable((observer) => {
      this.http.post(environment.prospektrBackendBaseURL + constants.API.userLogin, { userName, password }).subscribe(
        (res) => {
          // sessionStorage.clear();
          observer.next(res);
          observer.complete();
        },
        (err) => {
          observer.error({
            status: false,
            message: err.error && err.error.message ? err.error.message : 'Incorrect username or password',
          });
        }
      );
    });
  }

  navigatePostLogin(userRoles: string[]): void {
    // 🔹 Normalize URL
    const fullUrl = this.router.url;
    const cleanedPath = fullUrl.split('?')[0];
    const urlSegments = cleanedPath.split('/').filter(Boolean);

    // 🔹 Cleanup query params
    const queryParams = { ...this.activatedRoute.snapshot.queryParams };
    delete queryParams.login;
    if (queryParams.from === 'cmaSignUp') {
      delete queryParams.from;
    }

    // 🔹 Route flags
    const isEmptyRoute = urlSegments.length === 0;
    const isLoginRoute = urlSegments[0] === 'login';
    const isWorkspaceRoute = urlSegments[0] === 'workspace';

    // 🔹 Resolve target route
    const targetRoute = isEmptyRoute || isLoginRoute ? '/workspace/map' : '/' + urlSegments.join('/');

    // 🚀 Navigation logic (UNCHANGED)
    if (userRoles.includes('investor')) {
      this.appState.companyInfo$.subscribe((res: any) => {
        if (res) {
          this.companyName = res?.alias;
        }
      });
      if (this.companyName == 'opscan') {
        this.router.navigate(['/workspace/map'], {
          queryParams,
          replaceUrl: true,
          state: { skipUpdate: true },
        });
        return;
      } else {
        this.router.navigate([targetRoute], {
          queryParams,
          replaceUrl: true,
          state: { skipUpdate: true },
        });
        return;
      }
    }

    // 🔹 Non-investor logic
    if (isWorkspaceRoute || cleanedPath === '/workspace/map' || cleanedPath === '/workspace' || cleanedPath === '/listMyHome' || cleanedPath === '/listMyHome/homeDetails' || cleanedPath === '/listMyHome/myListings' || isLoginRoute) {
      this.joyrideService.closeTour();
      this.router.navigate(['/dashboard'], {
        replaceUrl: true,
        state: { skipUpdate: true },
      });
      return;
    }

    if (queryParams?.redirectTo) {
      const redirectTo = queryParams.redirectTo;

      this.router
        .navigate([urlSegments[0]], {
          queryParams: { redirectTo: redirectTo },
          replaceUrl: true,
          state: { skipUpdate: true },
        })
        .then((navigationSuccess) => {
          // if (navigationSuccess) {
          //   console.log('Navigation to /myClients successful!');
          // } else {
          //   console.log('Navigation failed!');
          // }
        });

      return;
    }

    this.router.navigate([targetRoute], {
      queryParams,
      replaceUrl: true,
      state: { skipUpdate: true },
    });
  }
}
